import Modal from "react-bootstrap/Modal";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { Button } from "@/shared/components/Button";
import { FaFileAlt } from "react-icons/fa";
import { Formik } from "formik";
import * as Yup from "yup";
import { editProject } from "../../../utils/services/user.service";
import { Ring } from "@uiball/loaders";
import { toast } from "react-toastify";
import { useChainContext } from "../../../containers/context/context";

const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    website: Yup.string().url("Invalid URL format"),
    description: Yup.string().required("Description is required"),
    email: Yup.string().email("Invalid email format"),
    phone_number: Yup.string(),
    explorer_link: Yup.string().url("Invalid URL format"),
    insta_link: Yup.string().url("Invalid URL format"),
    telegram_link: Yup.string().url("Invalid URL format"),
    x_link: Yup.string().url("Invalid URL format"),
    File: Yup.mixed().required("Banner image is required"),
    //   Documents: Yup.array().min(1, "At least one document is required"),
});

const EditProjectModal = ({ show, hide, data, reFetch }) => {
    const [selectedImage, setSelectedImage] = useState(data.image);
    const [showAlert, setShowAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const {reFethData, setReFetchData} = useChainContext();

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                setSelectedImage(event.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const removeImage = () => {
        setSelectedImage(null);
    };

    const handleCreateProject = async (val) => {

        setIsLoading(true); // Show loading indicator
        try {
            const formData = new FormData();
            // Append form values


            formData.append("project_id", data?._id || "");
            formData.append("name", val?.title || "");
            formData.append("File", selectedImage || null); // Banner image
            formData.append("File2", val?.Documents[0] || []); // PDF documents
            formData.append("website", val?.website || "");
            formData.append("description", val?.description || "");
            formData.append("email", val?.email || "");
            formData.append("phone_number", val?.phone_number || "");
            formData.append("explorer_link", val?.explorer_link || "");
            formData.append("insta_link", val?.insta_link || "");
            formData.append("telegram_link", val?.telegram_link || "");
            formData.append("x_link", val?.x_link || "");

            // Handle `locations` (string or array)
            const locations = Array.isArray(data?.locations) ? JSON.stringify(val.locations) : val.locations || "";
            formData.append("locations", locations);
            // API call
            const res = await editProject(formData);
            console.log("🚀 ~ handleCreateProject ~ res:", res)
            // Handle success response
            toast.success(res?.data?.Message || "Project created successfully!");
            setReFetchData(!reFethData)
            hide()

        } catch (error) {
            const errorMessage = error.response?.data?.Message || "Something went wrong";
            toast.error(errorMessage);
            console.error("🚀 ~ handleCreateProject ~ error:", error);
        } finally {
            setIsLoading(false); // Hide loading indicator
        }
    };

    return (
        <Modal size="lg" centered show={show} onHide={hide}>
            <Modal.Header closeButton>
                <Modal.Title className="text-center" style={{ fontSize: "large" }}>
                    <b>Edit Project</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div
                    className="loader-overlay"
                    style={{
                        display: isLoading ? 'flex' : 'none', // Use flex display when loading
                        justifyContent: 'center', // Center horizontally
                        alignItems: 'center', // Center vertically
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(255, 255, 255, 0.8)',
                        zIndex: 999999,
                    }}
                >
                    <Ring size={65} color="#00897B" />
                </div>
                <div className="container p-0">
                    <Formik
                        initialValues={{
                            title: data?.name,
                            website: data?.website,
                            description: data.description,
                            email: data.email,
                            phone_number: data.phone_number,
                            explorer_link: data.explorer_link,
                            insta_link: data.insta_link,
                            telegram_link: data.telegram_link,
                            x_link: data.x_link,
                            File: data.image,
                            Documents: data.document,
                        }}
                        validationSchema={validationSchema}
                        onSubmit={(values, { resetForm }) => {
                            handleCreateProject(values);
                            resetForm();
                        }}
                    >
                        {(props) => {
                            const {
                                values,
                                touched,
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                setFieldValue,
                            } = props;
                            return (
                                <form onSubmit={handleSubmit}>
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            {showAlert && (
                                                <div className="alert alert-danger text-center" role="alert">
                                                    {errorMessage}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {selectedImage && (
                                        <div>
                                            <img
                                                src={selectedImage}
                                                alt={`Banner`}
                                                style={{
                                                    width: "100%",
                                                    marginBottom: "10px",
                                                    minHeight: "400px",
                                                    maxHeight: "400px",
                                                    objectFit: "cover",
                                                    filter: "blur(1px)",
                                                }}
                                            />
                                            <Button
                                                onClick={removeImage}
                                                variant={"outline-danger"}
                                            >
                                                Remove Banner
                                            </Button>
                                        </div>
                                    )}

                                    <div className="row">
                                        {["title", "website", "description", "email", "phone_number", "explorer_link", "insta_link", "telegram_link", "x_link"].map((field) => (
                                            <div
                                                key={field}
                                                className="col-md-12 col-lg-4 col-sm-12 mb-2"
                                            >
                                                <InputDiv>
                                                    <label
                                                        htmlFor={field}
                                                        style={{ fontSize: "small" }}
                                                        className="form-label text-black"
                                                    >
                                                        {field.replace("_", " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                                                    </label>
                                                    <div>
                                                        <ChatSearchInput
                                                            type="text"
                                                            value={values[field]}
                                                            name={field}
                                                            id={field}
                                                            placeholder={`Enter ${field.replace("_", " ")}`}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            className={`form-control mt-2 ${errors[field] && touched[field] && "error"}`}
                                                        />
                                                        {errors[field] && touched[field] && (
                                                            <Error className="input feedback">
                                                                {errors[field]}
                                                            </Error>
                                                        )}
                                                    </div>
                                                </InputDiv>
                                            </div>
                                        ))}

                                        <div className="col-md-12 col-lg-4 col-sm-12 mb-2">
                                            <InputDiv>
                                                <label
                                                    htmlFor="File"
                                                    style={{ fontSize: "small" }}
                                                    className="form-label text-black"
                                                >
                                                    Upload Banner
                                                </label>
                                                <div>
                                                    <input
                                                        type="file"
                                                        id="File"
                                                        accept="image/*"
                                                        style={{ display: "none" }}
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            setFieldValue("File", file);
                                                            handleImageChange(e);
                                                        }}
                                                    />
                                                    <Button
                                                        type="button"
                                                        size="md"
                                                        className="py-2 btn-block"
                                                        variant="outline-info"
                                                        onClick={() => document.getElementById("File").click()}
                                                        disabled={selectedImage}
                                                    >
                                                        Choose Banner Image
                                                    </Button>
                                                    {errors.File && touched.File && (
                                                        <Error className="input feedback">
                                                            {errors.File}
                                                        </Error>
                                                    )}
                                                </div>
                                            </InputDiv>
                                        </div>

                                        <div className="col-md-12 col-lg-4 col-sm-12 mb-2">
                                            <InputDiv>
                                                <label
                                                    htmlFor="Documents"
                                                    style={{ fontSize: "small" }}
                                                    className="form-label text-black"
                                                >
                                                    Upload Documents
                                                </label>
                                                <div>
                                                    <input
                                                        type="file"
                                                        id="Documents"
                                                        accept="application/pdf"
                                                        multiple
                                                        style={{ display: "none" }}
                                                        onChange={(e) => {
                                                            const files = Array.from(e.target.files);
                                                            setFieldValue("Documents", [...values.Documents, ...files]);
                                                        }}
                                                    />
                                                    {values.Documents.length > 0 && (
                                                        <ul className="text-black">
                                                            {values.Documents.map((file, index) => (
                                                                <li key={index} className="d-flex justify-content-between">
                                                                    {file.name}
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            setFieldValue(
                                                                                "Documents",
                                                                                values.Documents.filter((_, i) => i !== index)
                                                                            );
                                                                        }}
                                                                    >
                                                                        Remove
                                                                    </Button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                    <Button
                                                        type="button"
                                                        size="md"
                                                        className="py-2 btn-block"
                                                        variant="outline-info"
                                                        onClick={() => document.getElementById("Documents").click()}
                                                    >
                                                        Choose Documents
                                                    </Button>
                                                    {errors.Documents && touched.Documents && (
                                                        <Error className="input feedback">
                                                            {errors.Documents}
                                                        </Error>
                                                    )}
                                                </div>
                                            </InputDiv>
                                        </div>
                                    </div>

                                    <div className="row mb-4">
                                        <div className="col-md-12 col-lg-4 col-sm-12" />
                                        <div className="col-md-12 col-lg-4 col-sm-12">
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <Button
                                                    type="submit"
                                                    size="md"
                                                    className="py-2 btn-block"
                                                    variant="outline-success"
                                                >
                                                    Create
                                                </Button>
                                            </div>
                                        </div>
                                        <div className="col-md-12 col-lg-4 col-sm-12" />
                                    </div>
                                </form>
                            );
                        }}
                    </Formik>
                </div>
            </Modal.Body>

        </Modal>
    );
};

export default EditProjectModal;

const InputDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  color: white;
  padding: 5px 0px;
  font-size: 14px;
`;

const ChatSearchInput = styled.input`
  width: 100%;
  height: 100%;
  font-size: 12px;
  transition: all 0.3s;
  background: transparent;
  border: none;
  padding-left: 2px;
  border-bottom: 1px solid #b1b1b1;
//   color: #b1b1b1;

  &:focus,
  &:active {
    outline: none;
    border-bottom: 2px solid #47c9a4;
  }

  &.error {
    border-bottom: 2px solid #ff4444;
  }
`;

const Error = styled.div`
  color: #ff4444;
  font-size: 12px;
  margin-top: 5px;
`;

const FeeMessage = styled.p`
  font-size: 14px;
  color: #b1b1b1;
  text-align: center;
  margin-top: 20px;
`;